import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/side-panel-close.webp'
import _imports_1 from '@/assets/cuffs_pl.png'
import _imports_2 from '@/assets/cuffs_en.png'
import _imports_3 from '@/assets/cuffs_pl_white.png'
import _imports_4 from '@/assets/cuffs_en_white.png'
import _imports_5 from '@/assets/side-panel-checkmark.png'
import _imports_6 from '@/assets/tms-side-panel-1-pl.svg'
import _imports_7 from '@/assets/tms-side-panel-2-pl.svg'
import _imports_8 from '@/assets/tms-side-panel-1-en.svg'
import _imports_9 from '@/assets/tms-side-panel-2-en.svg'
import _imports_10 from '@/assets/oanda-side-panel-1-en.svg'
import _imports_11 from '@/assets/oanda-side-panel-2-en.svg'


const _withScopeId = n => (_pushScopeId("data-v-be27b788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-panel__content-view fs-12" }
const _hoisted_2 = { class: "side-panel__header" }
const _hoisted_3 = { class: "side-panel__cuffs" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  src: _imports_1,
  alt: "Invest Cuffs 2023"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_2,
  alt: "Invest Cuffs 2023"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  src: _imports_3,
  alt: "Invest Cuffs 2023"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_4,
  alt: "Invest Cuffs 2023"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "side-panel__broker-grid"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "side-panel__broker-grid"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "side-panel__broker-grid"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["side-panel", { isClosed: _ctx.isClosed }])
  }, [
    _createElementVNode("img", {
      class: "side-panel__close",
      src: _imports_0,
      alt: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isClosed = true))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.awardWinningBroker`)), 1),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isDarkMode)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              (_ctx.UtilityHelper.getLocale() == _ctx.Locale.PL)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, [
              (_ctx.UtilityHelper.getLocale() == _ctx.Locale.PL)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : (_openBlock(), _createElementBlock("img", _hoisted_9))
            ]))
      ]),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.key
          }, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.${item.key}`)), 1)
          ]))
        }), 128))
      ]),
      (
                    !_ctx.UtilityHelper.isOandaPath() &&
                    _ctx.UtilityHelper.getLocale() == _ctx.Locale.PL
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
        : _createCommentVNode("", true),
      (
                    !_ctx.UtilityHelper.isOandaPath() &&
                    _ctx.UtilityHelper.getLocale() != _ctx.Locale.PL
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
        : _createCommentVNode("", true),
      (_ctx.UtilityHelper.isOandaPath())
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
        : _createCommentVNode("", true)
    ])
  ], 2))
}